// Environment helpers for gating dev-only affordances (e.g. the language
// switcher) so they ship ONLY to local and dev — never staging or production.
//
// - Local `vite dev` sets `import.meta.env.DEV` → always dev-like.
// - Built deploys (`vite build`) always have `DEV === false`, so a deployed
//   environment opts in only by setting `VITE_APP_ENV` to a dev-like value
//   (see DEV_LIKE_ENVS). `staging` and `production` are intentionally excluded.
// - When `VITE_APP_ENV` is unset in a build, it defaults to production (hidden).

export const APP_ENV: string = import.meta.env.VITE_APP_ENV ?? 'production'

// Deployed environments allowed to expose dev-only affordances. Local and dev
// only — staging and production are deliberately absent.
const DEV_LIKE_ENVS = ['local', 'development', 'dev']

// True in local `vite dev` and in an explicitly local/dev deployed environment.
export const isDevEnvironment: boolean =
  import.meta.env.DEV || DEV_LIKE_ENVS.includes(APP_ENV)
